import Client from 'config/axios';
import posthog from 'posthog-js';

export const deleteAmbassador = async (
  token: string,
  ambassadorId: any,
  groupId: any,
  removePermanent: any
) => {
  try {
    const url = `remove-ambassadors-to-groups?ambassadorsIds=[${ambassadorId}]&groupsIds=[${groupId}]&isRemovePermanent=${removePermanent}`;
    const { data } = await Client.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    posthog.capture('DeletedAmbassador', {
      DeletedAmbassador: data
    });
    return { data };
  } catch (response) {
    const result = response as any;
    return { errors: result.data };
  }
};
